module.exports = __webpack_public_path__ + "static/media/rock.ccc99289.svg";